import { Box, FormControl, Select, styled, MenuItem } from '@mui/material'
interface FilterSelectStyledProps {
  selectedCount: number
}

export const StyledFormControl = styled(FormControl)({
  minWidth: 66,
})

export const StyledSelect = styled(Select, {
  shouldForwardProp: (prop: string) => !['selectedCount'].includes(prop),
})<FilterSelectStyledProps>(({ theme, selectedCount }) => ({
  borderRadius: '16px',
  height: 32,
  padding: theme.spacing(0.5, 0.625),
  backgroundColor:
    selectedCount > 0 ? theme.palette.secondary.light : 'transparent',
  '& .MuiSelect-select': {
    display: 'flex',
    alignItems: 'center',
    height: '100%',
    padding: 0,
  },
  '&:hover': {
    backgroundColor:
      selectedCount > 0
        ? theme.palette.stateColors?.filledChipHover
        : theme.palette.action.hover,
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.action.disabled,
    },
  },
  '&.Mui-focused': {
    '& .MuiOutlinedInput-notchedOutline': {
      backgroundColor: theme.palette.action.hover,
      border: 'none',
    },
  },
}))
export const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  minWidth: '240px',
  padding: theme.spacing(1.5, 2),
  gap: theme.spacing(2),
  '& .MuiTouchRipple-root .MuiTouchRipple-child': {
    backgroundColor: theme.palette.grey[700],
  },

  '&.Mui-selected': {
    backgroundColor: theme.palette.common.white,

    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  },

  '&.Mui-selected.Mui-focusVisible': {
    backgroundColor: theme.palette.action.focus,
  },

  '&.Mui-focusVisible': {
    backgroundColor: theme.palette.action.hover,
  },
}))
export const SelectedValueBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  height: '100%',
  borderRadius: '16px',
  fontWeight: 500,
  margin: theme.spacing(0, 0.5),
}))

export const CountBadge = styled(Box)(({ theme }) => ({
  ...theme.typography.subtitle2,
  backgroundColor: theme.palette.secondary.main,
  color: theme.palette.common.white,
  borderRadius: '50%',
  width: 20,
  height: 20,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginRight: theme.spacing(0.75),
}))
